import cls from "./Table.module.scss";
import moneyIcon from "../../shared/assets/images/money.svg";
import { useDispatch } from "react-redux";
import { resetCount, setPause } from "../../shared/redux/game/slice";
import { Scrollbar } from "../../shared/ui/Scrollbar/Scrollbar";
import { useEffect, useState } from "react";
import { getUsersTop, userType } from "../../shared/ui/Api/getFunc";
import router, { ROUTES } from "../../app/router";
import { FormattedMessage, useIntl } from "react-intl";

const Table = () => {
  const [users, setUsers] = useState<userType[]>([]);
  const dispatch = useDispatch();
  const intl = useIntl();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedUsers = await getUsersTop();
        setUsers(fetchedUsers);
      } catch (error) {
        console.error("Произошла ошибка при получении счета:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className={cls.container}>
      <div className={cls.contentContainer}>
        <h2>
          <FormattedMessage id="leaderboard__title" />
        </h2>
        <Scrollbar
          children={
            <div className={cls.listContainer}>
              <ul>
                {users
                  .sort((a, b) => a.position - b.position) // Сортировка пользователей по полю position
                  .map((user) => (
                    <li key={user.position}>
                      <div className={cls.name}>
                        {user.username
                          ? user.username
                          : user.position % 2 === 0
                            ? intl.formatMessage({ id: "fake-player1" })
                            : intl.formatMessage({ id: "fake-player2" })}
                      </div>
                      <div className={cls.counter}>
                        <img
                          alt="Money"
                          src={moneyIcon}
                          className={cls.moneyIcon}
                        />
                        <div>{user.score}</div>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          }
        />
        <button
          onClick={() => {
            dispatch(resetCount());
            dispatch(setPause(false));
            router.navigate(ROUTES.GAME);
          }}
        >
          <FormattedMessage id="leaderboard__btn-text" />
        </button>
      </div>
    </div>
  );
};

export default Table;
